import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // Import Firebase Storage

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD8swqVVQxXZtL86Mxn6EVHKgFMKXCj86M",
  authDomain: "ai-project-23407.firebaseapp.com",
  projectId: "ai-project-23407",
  storageBucket: "ai-project-23407.firebasestorage.app", // Fixed storageBucket URL
  messagingSenderId: "701135116143",
  appId: "1:701135116143:web:cdc13d69011addb81f7a9a",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication, Firestore, and Storage
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app); // Initialize Storage

export { auth, db, storage };
